/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//just types
// import { Ticket } from '@touchplan/common';
// import { FancyAction, CombinedFancyActions, FancyActionTypes } from "src/app/common/fancy-firebase/base";

import { IConnectedCamera } from '../interfaces/connected-camera.interface';
import { Plan, TicketScale } from '@touchplan/common';

export interface SessionSettings {
	hideCompletedTickets?: boolean;
}

//types/ interfaces
export type CombinedSupplementalActions =
	// | CombinedFancyActions<Ticket>
	| PlanUpdatedAction
	| PullColumnsUpdated
	| MilestoneUpdatedAction
	| SessionSettingsAction
	| CameraChangedAction
	| TicketScaleChangedAction;

export interface PlanUpdatedAction extends FancySupplementalAction {
	type: SupplementalActionTypes.planUpdated;
	payload: Plan; //Plan
}
export interface PullColumnsUpdated extends FancySupplementalAction {
	type: SupplementalActionTypes.pullColumnsUpdated;
	payload: Map<string, any>;
}
export interface MilestoneUpdatedAction extends FancySupplementalAction {
	type: SupplementalActionTypes.milestoneUpdated;
	payload: { x: number; date: string };
}
export interface SessionSettingsAction extends FancySupplementalAction {
	type: SupplementalActionTypes.sessionSettingsChanged;
	payload: SessionSettings;
}
export interface CameraChangedAction extends FancySupplementalAction {
	type: SupplementalActionTypes.cameraChanged;
	payload: IConnectedCamera;
}

export interface TicketScaleChangedAction extends FancySupplementalAction {
	type: SupplementalActionTypes.ticketScaleChanged;
	payload: TicketScale;
}

/**
 * The core data structure to be passed to an observer.
 * @param payload Generally expected to be a ticket or an object representing a ticket.
 * Each action type will expect something different and specific.
 * @param type    The type of action. TODO - look into doing this class based instead of enum
 * @param key     Optional if the payload is a Ticket, otherwise required.
 */

export class FancySupplementalAction<T = any> {
	constructor(
		public payload: T, //Plan
		public type: string,
		public key?: string //won't always need a key
	) {}
}

// type definition enum
export enum SupplementalActionTypes {
	planUpdated = 'plan_updated',
	pullColumnsUpdated = 'pull_columns_updated',
	milestoneUpdated = 'milestone_updated',
	varianceListUpdated = 'variance_list_updated',
	sessionSettingsChanged = 'session_settings_changed',
	cameraChanged = 'camera_changed',
	planArchivedChanged = 'plan_archived_changed',
	ticketScaleChanged = 'ticket_scale_changed',
}
